"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../../components/Box");
exports.Container = react_1.forwardRef((_a, ref) => {
    var { center } = _a, rest = __rest(_a, ["center"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, width: 1400, maxWidth: "100%", px: 3, marginX: center ? 'auto' : 0 }, rest), void 0));
});
//# sourceMappingURL=index.js.map